import { CLEAN_REDUCER } from '../../constants/actionTypes';
import { LOG_OUT } from '../auth/actionTypes';
import { ADD_CARRIERS_SUCCESS, EDIT_CARRIERS_SUCCESS, FETCH_CARRIERS, FETCH_CARRIERS_COUNT } from './actionTypes';

const initState = {
	list: [],
	editable: {},
	count: 0,
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case FETCH_CARRIERS_COUNT:
			return {
				...state,
				count: action.count,
			};
		case ADD_CARRIERS_SUCCESS: {
			return {
				...state,
				list: action.payload,
				count: action.count,
			};
		}
		case EDIT_CARRIERS_SUCCESS: {
			return {
				...state,
				list: action.carriers,
			};
		}
		case FETCH_CARRIERS:
			return {
				...state,
				list: action.payload,
			};
		case CLEAN_REDUCER:
			return initState;
		case LOG_OUT:
			return initState;
		default:
			return state;
	}
};

export default reducer;
